module.exports = __webpack_public_path__ + "static/ic_subscribe.0aedd813.png";